import { render, staticRenderFns } from "./MyProgramMetrics.vue?vue&type=template&id=7ecf2d22&scoped=true"
import script from "./MyProgramMetrics.vue?vue&type=script&lang=ts"
export * from "./MyProgramMetrics.vue?vue&type=script&lang=ts"
import style0 from "./MyProgramMetrics.vue?vue&type=style&index=0&id=7ecf2d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf2d22",
  null
  
)

export default component.exports